import * as React from 'react';
// eslint-disable-next-line import/prefer-default-export
export const TranslationContext = React.createContext({
  lang: 'en',
  setLang: (lang: string) => {}
});